<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">在线留言</div>
						<div class="txt">留下您的联系方式和建议，以便我们对您反馈与产品改进。</div>
					</div>
					<div class="form_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<div class="left_el">
								<div class="tit">姓名：</div>
								<div class="input_el">
									<input v-model="username" />
								</div>
								<div class="tips">*</div>
							</div>
							<div class="left_el">
								<div class="tit">电话：</div>
								<div class="input_el">
									<input v-model="phone" />
								</div>
								<div class="tips">*</div>
							</div>
							<div class="left_el">
								<div class="tit">邮箱：</div>
								<div class="input_el">
									<input v-model="email" />
								</div>
								<div class="tips">*</div>
							</div>
						</div>
						<div class="right">
							<div class="tit">留言内容：</div>
							<div class="textarea_el">
								<textarea v-model="content"></textarea>
							</div>
						</div>
					</div>
					<div class="msg_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left_box">
							<div class="left_el" style="font-size: 16px;">
								<van-icon name="phone-o" size="18px" style="top: 4px;" />&nbsp;
								400 606 1166&ensp;|&ensp;010-69391166
								&ensp;&ensp;&ensp;&ensp;<van-icon name="envelop-o" size="18px" style="top: 4px;" />&nbsp;
								<a href="mailto:liang@cordx.com">liang@cordx.com</a>
							</div>
							<div class="left_el">
								{{ $t('footer.text1') }}<span style="font-size: 16px;">5900 Windward Pkwy. Alpharetta, GA 30005 USA</span>
							</div>
							<div class="left_el">
								{{ $t('footer.text2') }}
							</div>
							<div class="left_el">
								{{ $t('footer.text3') }}
							</div>
						</div>
						<div class="right_box">
							<div class="btn_box" @click="submit">提交</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
	</div>
</template>

<script>
import { submitMsg } from '@/api/public'  //提交留言
import md5 from 'js-md5';
export default {
	components:{
		//
	},
	data() {
		return {
			username: '',
			phone: '',
			email: '',
			content: ''
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		submit() {
			let that = this;
			if(that.username && that.phone && that.email) {
				that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
				submitMsg({
					name: that.username,
					mobile: that.phone,
					email: that.email,
					content: that.content,
					language: sessionStorage.getItem('lang'),
					access_token: md5(String(that.username)+String(that.email)+String(that.phone)+'CoretestsByAiiso')
				}).then(res => {
					that.$toast.clear();
					that.username = '';
					that.phone = '';
					that.email = '';
					that.content = '';
					that.$toast('提交成功');
				});
			}else {
				that.$toast('请先完善留言信息');
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 150px 0;
		background: url(../../../assets/img_public/about/contact/banner01.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			.msg_box{
				display: flex;
				.right_box{
					width: auto;
					.btn_box{
						width: 200px;
						height: 58px;
						line-height: 58px;
						font-size: 20px;
						text-align: center;
						color: #ffffff;
						background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
						border-radius: 8px 8px 8px 8px;
						cursor: pointer;
					}
				}
				.left_box{
					flex: 1;
					.left_el{
						padding-bottom: 10px;
						a{
							color: #000000;
						}
						a:hover{
							color: #A50073;
						}
					}
				}
			}
			.form_box{
				display: flex;
				padding: 60px 0 30px 0;
				.right{
					flex: 1;
					display: flex;
					margin: 20px 0 20px 32px;
					padding: 14px 24px;
					background-color: #ffffff;
					border-radius: 12px;
					.textarea_el{
						flex: 1;
						textarea{
							width: 100%;
							height: 100%;
							border: none;
							font-size: 18px;
							resize: none;
						}
					}
					.tit{
						width: auto;
						font-size: 18px;
					}
				}
				.left{
					flex: 1;
					padding-right: 32px;
					.left_el{
						height: 58px;
						display: flex;
						align-items: center;
						margin: 20px 0;
						padding: 0 24px;
						background-color: #ffffff;
						border-radius: 12px;
						.input_el{
							flex: 1;
							input{
								width: 100%;
								height: 58px;
								padding: 0 12px 0 4px;
								font-size: 18px;
								border: none;
							}
						}
						.tips{
							width: auto;
							position: relative;
							top: 5px;
							font-size: 20px;
							color: #A20073;
						}
						.tit{
							width: auto;
							font-size: 18px;
						}
					}
				}
			}
			.tit_box{
				text-align: center;
				.txt{
					padding-top: 10px;
					font-size: 16px;
				}
				.tit{
					font-size: 48px;
				}
			}
		}
	}
}
</style>